module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/10-475b625582dd4b61890b9f77045b061d.svg";